import { render } from "./ReviewRentalForm.vue?vue&type=template&id=d6b89272"
import script from "./ReviewRentalForm.vue?vue&type=script&lang=js"
export * from "./ReviewRentalForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__